// Per-user saved views for the All Cases list (saved_views_logic.md). Thin wrapper
// over /api/me/views — apiFetch attaches the bearer token; views are always the
// caller's own.
import { apiFetch } from './apiFetch.js';

export async function listSavedViews() {
  const data = await apiFetch('/api/me/views');
  return Array.isArray(data?.views) ? data.views : [];
}

export function createSavedView({ name, isDefault = false, view }) {
  return apiFetch('/api/me/views', { method: 'POST', body: JSON.stringify({ name, isDefault, view }) });
}

export function updateSavedView(id, patch) {
  return apiFetch(`/api/me/views/${id}`, { method: 'PATCH', body: JSON.stringify(patch) });
}

export function deleteSavedView(id) {
  return apiFetch(`/api/me/views/${id}`, { method: 'DELETE' });
}
